<script setup lang="ts">
import { computed } from 'vue'
import { versionInfo } from './version'

// Badge discreto de versão/build (REL-UI-02). Em superfícies escuras passe
// dark; o padrão serve fundos claros.
withDefaults(defineProps<{ dark?: boolean }>(), { dark: false })

const info = computed(() => versionInfo())
</script>

<template>
    <span
        class="version-badge"
        :class="{ 'is-dark': dark }"
        :title="`Versão ${info.version}${info.sha ? ' · ' + info.sha : ''} · ${info.env}`"
    >
        {{ info.label }}
    </span>
</template>

<style scoped>
.version-badge {
    display: inline-block;
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    font-size: 10px;
    font-weight: 500;
    line-height: 1.2;
    letter-spacing: 0.02em;
    color: #9ca3af;
    opacity: 0.7;
    white-space: nowrap;
}
.version-badge.is-dark {
    color: #9ca3af;
    opacity: 0.85;
}
</style>
